import { MantineProvider } from '@mantine/core'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { PropsWithChildren } from 'react'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter as Router } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'

import { LanguageInitializer } from '../common/components/LanguageInitializer/LanguageInitializer'
import { useColorTheme } from '../common/hooks/useColorTheme/useColorTheme'
import { config } from '../config/config'
import { AuthContextController } from '../context/auth/authContextController/AuthContextController'
import { BadgeEarnedPopupContextController } from '../context/badgeEarnedPopup/badgeEarnedPopupContextController/BadgeEarnedPopupContextController'
import { RateLimitContextController } from '../context/rateLimit/rateLimitContextController/RateLimitContextController'

import { LemonadeProvider } from '@percent/lemonade'
import { AnalyticsContextController } from '@percent/workplace-giving/context/analytics/analytics/AnalyticsContextController/AnalyticsContextController'
import { ClientContextController } from '@percent/workplace-giving/context/client/clientContextController/ClientContextController'
import { LoggerContextController } from '@percent/workplace-giving/context/logger/LoggerContextController/LoggerContextController'
import i18n from '@percent/workplace-giving/i18n/config'
import { ReactRouter6Adapter } from '@percent/workplace-giving/utils/queryParamsAdapter'
import { PostHogProvider } from './PostHogProvider/PostHogProvider'

export function AppProviders({ children }: Readonly<PropsWithChildren>) {
  const { theme } = useColorTheme()

  return (
    <LoggerContextController>
      <GoogleOAuthProvider clientId={config.keys.googleClientId || ''}>
        <MantineProvider
          withStaticClasses
          theme={{
            fontSizes: {
              md: '14px'
            }
          }}
        >
          <LemonadeProvider customPalette={theme}>
            <I18nextProvider i18n={i18n}>
              <ClientContextController>
                <RateLimitContextController>
                  <AnalyticsContextController>
                    <AuthContextController>
                      <PostHogProvider>
                        <LanguageInitializer>
                          <BadgeEarnedPopupContextController>
                            <Router>
                              <QueryParamProvider adapter={ReactRouter6Adapter}>{children}</QueryParamProvider>
                            </Router>
                          </BadgeEarnedPopupContextController>
                        </LanguageInitializer>
                      </PostHogProvider>
                    </AuthContextController>
                  </AnalyticsContextController>
                </RateLimitContextController>
              </ClientContextController>
            </I18nextProvider>
          </LemonadeProvider>
        </MantineProvider>
      </GoogleOAuthProvider>
    </LoggerContextController>
  )
}
